import React from 'react';
import { useTranslation } from 'react-i18next';
import { EmptyState } from '@wix/design-system';

export const ErrorPage = () => {
  const { t } = useTranslation();
  return (
    <EmptyState
      theme="page"
      image={
        <div
          style={{
            height: 120,
            width: 120,
            backgroundColor: '#dfe5eb',
            borderRadius: '50%',
          }}
        />
      }
      title={t(
        'charge-locator.results-page.full-page.suspicious-search-activity.title',
      )}
      subtitle={t(
        'charge-locator.results-page.full-page.suspicious-search-activity.subtitle',
      )}
    />
  );
};
